import { cn } from "@/ds/utils";
import { LockIcon } from "lucide-react";
import type React from "react";
import { Link } from "react-router";

export interface PadlockProps<T> {
	on: T | null | undefined;
	children: (value: T) => React.ReactNode;
	className?: string;
}

export const Padlock = <T,>(props: PadlockProps<T>): React.JSX.Element => {
	const {
		on,
		children,
		className
	} = props;

	const iconClassName = cn("size-4 text-muted-foreground", className);

	if (on === null || on === undefined) {
		return (
			<Link to="/settings/subscription">
				<LockIcon className={iconClassName} />
			</Link>
		);
	}

	return <>{children(on)}</>;
};
